import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { ColorAnimationService } from '@ethic/shared/color-animation';
import { SharedLinks } from '@ethic/shared/configurations';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { BrowserDetectionService } from './shared/services/browser-detection.service';
import { AppNotification, NotificationService } from './shared/services/notification.service';
import { LoginTypes } from './shared/types/login-types';

@UntilDestroy()
@Component({
  selector: 'lgn-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  readonly ethicLandingLink = SharedLinks.EthicMarketingSite;

  notification$: Observable<AppNotification>;
  loginType: LoginTypes;
  loginTypeMap = {
    [LoginTypes.Ethic]: {
      welcomeText: environment.rootPageText.welcomeText,
      title: environment.rootPageText.titleText,
    },
    [LoginTypes.Zendesk]: {
      welcomeText: 'Welcome to the',
      title: 'Ethic Helpdesk',
    },
  };

  isPageLoad = false;
  rootCssClass = environment.rootCssClass;
  environmentSite = environment.environmentSite;

  @HostBinding('class.hide-left-page-part') hideLeftPagePart = true;
  @HostBinding('class') classes = environment.rootCssClass;
  @HostBinding('class.color-animation-enabled') colorEnabled = environment.colorAnimationEnabled;

  constructor(
    public notificationService: NotificationService,
    private browserDetectionService: BrowserDetectionService,
    private router: Router,
    private route: ActivatedRoute,
    public colorAnimation: ColorAnimationService
  ) {
    this.notification$ = notificationService.notification$;
  }

  ngOnInit() {
    const browserDetected = this.browserDetectionService.defineBrowser();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentPage = this.router.url.split('?')[0].split('/').pop();
        this.hideLeftPagePart = currentPage === 'change-password.html';
      }
      this.isPageLoad = true;
    });

    this.route.queryParams.pipe(untilDestroyed(this)).subscribe((params: Params) => {
      this.loginType = params['type'] || LoginTypes.Ethic;
    });

    if (
      browserDetected !== 'Google Chrome or Chromium' &&
      browserDetected !== 'Apple Safari' &&
      this.environmentSite !== 'community'
    ) {
      this.router.navigateByUrl('/browser-support.html', { replaceUrl: true });
    }

    if (environment.colorAnimationEnabled) {
      this.colorAnimation.runAnimation();
    }
  }

  // get login type
  get currentLoginType() {
    return this.loginTypeMap[this.loginType];
  }
}
